






























































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Account } from "@/models/account";
import loader from "@/components/loader.vue";
import accountsApi from "@/services/accounts";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import moment from "moment";

import { NSLog } from "@/helpers/log";
import OrderHelpers, { Order } from "../../models/order";
import FlagIcon from "@/components/FlagIcon.vue";
import { ServiceMatrix } from "@/models/serviceMatrix";
import { Warehouse } from "@/models/warehouse";
const log = NSLog("view/PlaceUserOrder");

const FRIENDLY_SHIPPING_PROVIDER_MAP: { [key: string]: string } = {
  SHPFixedUSToUS: "Fixed US to US",
  SHPFixedZAToZA: "Fixed ZA to ZA",
  FreshEffects: "Fresh-effects",
  SHPZALexieToZA: "Fixed Lexie ZA to ZA"
};

@Component({
  components: {
    loader,
    FlagIcon,
  },
})
export default class DestinationRegion extends Vue {
  private loading = false;
  @Mutation("setLastErr") private setLastErr: any;

  // order passed as prop, then emit('update',{field: value}, sync?) to update.
  @Prop({ required: true }) private order?: Order;

  @Getter("serviceMatrix") serviceMatrix!: ServiceMatrix[];
  @Getter("warehouses") warehouses!: Warehouse[];
  get items() {
    return this.serviceMatrix
      .filter((i) => {
        if (!i.active) return false;
        for (let key in this.filters) {
          if (this.filters[key] !== (i as any)[key]) return false;
        }
        return true;
      })
      .map((s) => {
        const wh = this.warehouses.find((wh) => s.warehouse_id == wh.id);

        return {
          ...s,
          payment_provider: (s.payment_provider || "None")
            .replaceAll(/[_-]/gi, " ")
            .toUpperCase(),
          billing_provider: (s.billing_provider || "None")
            .replaceAll(/[_-]/gi, " ")
            .toUpperCase(),
          email_provider: (s.email_provider || "None")
            .replaceAll(/[_-]/gi, " ")
            .toUpperCase(),
          tax_provider: (s.tax_provider || "None")
            .replaceAll(/[_-]/gi, " ")
            .toUpperCase(),
          shipping_provider:
            FRIENDLY_SHIPPING_PROVIDER_MAP[s.shipping_provider || ""] ||
            s.shipping_provider,
          warehouse: wh ? wh.name : "",
        };
      });
  }

  private filters: { [key: string]: any } = {};

  get headers() {
    return [
      // { text: "Id", value: "id" },
      { text: "Ship from warehouse", value: "warehouse" },

      { text: "Ship from region", value: "src_region" },
      { text: "Destination region", value: "dst_region" },
      { text: "Invoice Currency", value: "invoice_currency" },
      { text: "Charge Currency", value: "bill_currency" },
      // { text: "Billing Provider", value: "billing_provider" },
      // { text: "Payment Provider", value: "payment_provider" },
      // { text: "Email Provider", value: "email_provider" },
      // { text: "Tax Provider", value: "tax_provider" },
      // { text: "Shipping Provider", value: "shipping_provider" },
      { text: "More", value: "more" },
      // { text: "Active", value: "active" },
      // { text: "Created At", value: "created_at" },
      // { text: "Updated At", value: "updated_at" },

      // {
      //   text: "Title",
      //   align: "left",
      //   sortable: true,
      //   value: "title",
      // },
      // { text: "Interval", value: "interval" },
      // { text: "Price", value: "price" },
      // { text: "Currency", value: "currency" },
      // // { text: "Expiry", value: "expiry" },
      // { text: "Updated", value: "updated_at" },
    ];
  }

  setServiceMatrixId(id: number, cur: string) {
    this.$emit(
      "update",
      {
        service_matrix_id: id,
        currency: cur === "ZAR" ? "ZAR" : "USD",
        currency_estimated: "",
      },
      true,
      "customer"
    );
  }
}
